import { render, staticRenderFns } from "./SuggestMenu.vue?vue&type=template&id=58bdbc6a&"
import script from "./SuggestMenu.vue?vue&type=script&lang=js&"
export * from "./SuggestMenu.vue?vue&type=script&lang=js&"
import style0 from "./SuggestMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports